<div class=" flex justify-content-center overflow-x-auto">
    <p-organizationChart [value]="data" selectionMode="multiple" [(selection)]="selectedNodes" [collapsible]="true">
        <ng-template let-node pTemplate="person">
            <div class="p-2 text-center">
                <img [src]="node.data.image" class="mb-3 w-3rem h-3rem" />
                <div class="font-bold">
                    {{ node.data.name }}
                </div>
                <div>
                    {{ node.data.title }}
                </div>
            </div>
        </ng-template>
    </p-organizationChart>
</div>